import AbstractAction from 'AbstractAction';
import openDialog from 'actions/utilities/openDialog';

module.exports = AbstractAction.extend({
  execute: function (selected) {
    openDialog(this, selected);
  }
});